import { Link } from "react-router-dom";
import Footer from "./Footer";
const Bases = () => {
    return (
        <>
           <div className="fondoBases">
           <div className="container pt-5">
                <div className="row d-flex justify-content-center ">
                    <div className="col-sm-7 contenedorBases">
                    <h1 className="text-center mb-5 tituloBases">BASES</h1>
                        <ul className="textosBases">
                            <li><h5>Pueden participar todos los cuentahabientes de Martha Debayle, deberán de tener ID a la hora de registrar el arbolito. (Para obtener uno, registra tus datos de contacto: Nombre completo, teléfono, correo electrónico en este link: <a className="url" href="https://mmkg.net/registro" target="blank"> mmkg.net/registro.</a>)</h5></li><br/>
                            <li><h5>Tienen del 15 de diciembre al 31 de diciembre para poder subir la foto de su arbolito de navidad. Deberán salir a lado del árbol de navidad como testigo de que es suyo. </h5></li><br/>
                            <li><h5>Las fotografías no deberán de exceder los 250 kbs, si pesan más podrían no subir durante el registro.</h5></li><br/>
                             <li><h5>El staff del programa de radio seleccionará a los 3 mejores árboles de navidad, se llevarán alegrías y se anunciarán en el programa de radio a partir de enero 2026.</h5></li><br/>
                        </ul>
                    </div>                   
                </div>
                <div className="col-12 text-center pb-5">
                {/* <Link className="btn botonResgistro text-uppercase" to="/Registro">REGÍSTRATE</Link>
                <Link className="btn botonResgistro text-uppercase" to="https://mmkg.net/registro" target="_blank">Crea tu ID</Link> */}
                </div>

            </div>
           </div>
            <Footer/>
        </>
    )
}
export default Bases;